

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/privacy/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.4d573cae.js","_app/immutable/chunks/scheduler.44d63395.js","_app/immutable/chunks/index.ddc1e9bc.js","_app/immutable/chunks/Loading.924602c4.js","_app/immutable/chunks/index.651c7174.js"];
export const stylesheets = ["_app/immutable/assets/Loading.0a6197f8.css"];
export const fonts = [];
